import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "log-details-expanded p-3 bg-light border-top" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = {
  key: 0,
  class: "col-lg-8"
}
const _hoisted_4 = {
  key: 0,
  class: "card border-success"
}
const _hoisted_5 = { class: "card-header bg-success text-white" }
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_9 = { class: "text-muted d-block" }
const _hoisted_10 = {
  style: {"word-break":"break-all","overflow-wrap":"break-word","max-width":"100%","white-space":"normal"},
  class: "fw-medium"
}
const _hoisted_11 = { class: "card border-warning" }
const _hoisted_12 = { class: "card-header bg-warning text-dark" }
const _hoisted_13 = { class: "card-body" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-md-6" }
const _hoisted_16 = {
  key: 0,
  class: "p-2 bg-danger bg-opacity-10 border border-danger rounded"
}
const _hoisted_17 = { class: "text-muted d-block" }
const _hoisted_18 = {
  style: {"word-break":"break-all","overflow-wrap":"break-word","max-width":"100%","white-space":"normal"},
  class: "text-decoration-line-through text-danger"
}
const _hoisted_19 = {
  key: 1,
  class: "mb-2"
}
const _hoisted_20 = { class: "text-muted d-block" }
const _hoisted_21 = { style: {"word-break":"break-all","overflow-wrap":"break-word","max-width":"100%","white-space":"normal"} }
const _hoisted_22 = { class: "col-md-6" }
const _hoisted_23 = {
  key: 0,
  class: "p-2 bg-success bg-opacity-10 border border-success rounded"
}
const _hoisted_24 = { class: "text-muted d-block" }
const _hoisted_25 = {
  style: {"word-break":"break-all","overflow-wrap":"break-word","max-width":"100%","white-space":"normal"},
  class: "fw-bold text-success"
}
const _hoisted_26 = {
  key: 1,
  class: "mb-2"
}
const _hoisted_27 = { class: "text-muted d-block" }
const _hoisted_28 = { style: {"word-break":"break-all","overflow-wrap":"break-word","max-width":"100%","white-space":"normal"} }
const _hoisted_29 = { class: "card border-info" }
const _hoisted_30 = { class: "card-body" }
const _hoisted_31 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_32 = { class: "row" }
const _hoisted_33 = { class: "col-md-6" }
const _hoisted_34 = {
  key: 0,
  class: "p-2 bg-danger bg-opacity-10 border border-danger rounded"
}
const _hoisted_35 = { class: "text-muted d-block" }
const _hoisted_36 = {
  style: {"word-break":"break-all","overflow-wrap":"break-word","max-width":"100%","white-space":"normal"},
  class: "text-decoration-line-through text-danger"
}
const _hoisted_37 = { class: "col-md-6" }
const _hoisted_38 = {
  key: 0,
  class: "p-2 bg-success bg-opacity-10 border border-success rounded"
}
const _hoisted_39 = { class: "text-muted d-block" }
const _hoisted_40 = {
  style: {"word-break":"break-all","overflow-wrap":"break-word","max-width":"100%","white-space":"normal"},
  class: "fw-bold text-success"
}
const _hoisted_41 = { class: "card border-danger" }
const _hoisted_42 = { class: "card-header bg-danger text-white" }
const _hoisted_43 = { class: "card-body" }
const _hoisted_44 = { class: "text-muted mb-0" }
const _hoisted_45 = { class: "col-lg-4" }
const _hoisted_46 = {
  key: 0,
  class: "card border mb-3"
}
const _hoisted_47 = { class: "card-body" }
const _hoisted_48 = { class: "mb-1" }
const _hoisted_49 = { style: {"word-break":"break-all","overflow-wrap":"break-word","max-width":"100%","white-space":"normal"} }
const _hoisted_50 = {
  key: 0,
  class: "mb-0 text-muted"
}
const _hoisted_51 = ["href"]
const _hoisted_52 = { class: "mb-0 text-muted" }
const _hoisted_53 = {
  key: 1,
  class: "card border mb-3"
}
const _hoisted_54 = { class: "card-body" }
const _hoisted_55 = { class: "mb-1" }
const _hoisted_56 = { style: {"word-break":"break-all","overflow-wrap":"break-word","max-width":"100%","white-space":"normal"} }
const _hoisted_57 = {
  key: 0,
  class: "mb-0 text-muted"
}
const _hoisted_58 = ["href"]
const _hoisted_59 = { class: "mb-0 text-muted" }
const _hoisted_60 = { class: "card border mb-3" }
const _hoisted_61 = { class: "card-body" }
const _hoisted_62 = { class: "mb-0" }
const _hoisted_63 = {
  key: 2,
  class: "card border mb-3"
}
const _hoisted_64 = { class: "card-body" }
const _hoisted_65 = { class: "mb-1" }
const _hoisted_66 = {
  key: 3,
  class: "card border mb-3"
}
const _hoisted_67 = {
  class: "card-body",
  style: {"min-width":"0"}
}
const _hoisted_68 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_69 = {
  key: 1,
  class: "mb-2",
  style: {"min-width":"0"}
}
const _hoisted_70 = { style: {"word-break":"break-all","overflow-wrap":"break-word","max-width":"100%","white-space":"normal"} }
const _hoisted_71 = {
  key: 2,
  class: "mb-2"
}
const _hoisted_72 = {
  key: 3,
  class: "mb-0"
}
const _hoisted_73 = { class: "card border" }
const _hoisted_74 = { class: "card-body" }
const _hoisted_75 = { class: "mb-2" }
const _hoisted_76 = { style: {"word-break":"break-all","overflow-wrap":"break-word","max-width":"100%","white-space":"normal"} }
const _hoisted_77 = ["href"]
const _hoisted_78 = { key: 1 }
const _hoisted_79 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_80 = { style: {"word-break":"break-all","overflow-wrap":"break-word","max-width":"100%","white-space":"normal"} }
const _hoisted_81 = { class: "mb-2" }
const _hoisted_82 = { style: {"word-break":"break-all","overflow-wrap":"break-word","max-width":"100%","white-space":"normal"} }
const _hoisted_83 = { class: "mb-2" }
const _hoisted_84 = { class: "mb-0" }
const _hoisted_85 = {
  key: 0,
  class: "badge bg-secondary"
}
const _hoisted_86 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_87 = { key: 2 }

import { computed } from "vue";
import { format, isValid } from "date-fns";
import { getActionLabel, getLogBookingKindLabel, isSeriesLevelLog } from "../../../../composables/useLogDisplay.js";
import { useRRuleBuilder } from "../../../../calendar/composables/useRRuleBuilder";


export default {
  __name: 'LogDetailsExpanded',
  props: {
	log: {
		type: Object,
		required: true,
	},
},
  setup(__props) {

const props = __props;

const ACTION_BADGE_CLASS = {
	created: "bg-success",
	changed: "bg-warning",
	cancelled: "bg-danger",
	extracted: "bg-info",
};

const actionBadgeClass = computed(() => ACTION_BADGE_CLASS[props.log.action] || "bg-secondary");

// Helper to safely get data from changes/metadata (handles arrays)
const safeGetData = (key) => {
	// First try from changes.new (if it's an object)
	if (props.log.changes?.new && typeof props.log.changes.new === 'object' && !Array.isArray(props.log.changes.new)) {
		const value = props.log.changes.new[key];
		if (value) return value;
	}
	
	// Then try from metadata (if it's an object)
	if (props.log.metadata && typeof props.log.metadata === 'object' && !Array.isArray(props.log.metadata)) {
		const value = props.log.metadata[key];
		if (value) return value;
	}
	
	return null;
};

// Computed properties for employee and student data
const employeeData = computed(() => {
	return safeGetData('employeeData');
});

const studentData = computed(() => {
	return safeGetData('studentData');
});

// Computed properties for booking type and room data
const bookingTypeData = computed(() => {
	return safeGetData('bookingTypeData');
});

const roomData = computed(() => {
	return safeGetData('roomData');
});

// Safe computed properties for changes arrays
const safeChangesNew = computed(() => {
	const changes = props.log.changes?.new;
	if (!changes) return {};
	if (Array.isArray(changes)) return {};
	if (typeof changes === 'object') return changes;
	return {};
});

const safeChangesOld = computed(() => {
	const changes = props.log.changes?.old;
	if (!changes) return {};
	if (Array.isArray(changes)) return {};
	if (typeof changes === 'object') return changes;
	return {};
});

// Combined room data for display - prefers detailed roomData but falls back to main room object
const displayRoomData = computed(() => {
	const detailed = roomData.value;
	const main = props.log.room;

	// Prefer detailed room data if available, otherwise use main room data
	return detailed || main || null;
});

// Helper functions
const formatDate = (date) => {
	if (!date) return "-";
	const parsed = new Date(date);
	return isValid(parsed) ? format(parsed, "dd.MM.yyyy HH:mm:ss") : "Invalid Date";
};

const getFieldLabel = (key) => {
	const labels = {
		startTime: "Startzeit",
		endTime: "Endzeit",
		title: "Titel",
		description: "Beschreibung",
		room: "Raum ID",
		employee: "Mitarbeiter-Nr.",
		student: "MNR",
		bookingType: "Typ",
		series: "Serie",
		pattern: "Wiederholung",
		cancellations: "Ausfalltermine",
		modifiedAt: "Geändert am",
	};
	return labels[key] || key;
};

const formatPattern = (pattern) => {
	if (!pattern) return "-";
	try {
		return useRRuleBuilder().getHumanReadable(pattern);
	} catch (error) {
		console.warn("Pattern formatting error:", error);
		return pattern;
	}
};

const formatDateList = (dates) => {
	if (!Array.isArray(dates) || dates.length === 0) return "Keine";
	return dates.map((date) => {
		const parsed = new Date(date);
		return isValid(parsed) ? format(parsed, "dd.MM.yyyy") : "Invalid Date";
	}).join(", ");
};

const formatFieldValue = (key, value) => {
	if (key === "cancellations") return formatDateList(value);
	// a plain "-" for an empty title/description reads as "value unknown" in a before/after
	// diff — spell out that it was genuinely empty instead
	if (key === "title" && !value) return "Kein Titel";
	if (key === "description" && !value) return "Keine Beschreibung";
	if (value === null || value === undefined) return "-";

	switch (key) {
		case "startTime":
		case "endTime":
		case "modifiedAt":
			const parsed = new Date(value);
			return isValid(parsed) ? format(parsed, "dd.MM.yyyy HH:mm") : "Invalid Date";
		case "pattern":
			return formatPattern(value);
		case "bookingType":
			const typeLabels = {
				1: "Üben",
				2: "Konzert",
				3: "Prüfung",
			};
			return typeLabels[value] || `Typ ${value}`;
		case "bookingTypeData":
		case "roomData":
		case "employeeData":
		case "studentData":
			// These should be hidden by shouldShowField, but if they get through, don't show [object Object]
			return typeof value === 'object' ? JSON.stringify(value, null, 2) : value.toString();
		default:
			return typeof value === 'object' ? JSON.stringify(value, null, 2) : value.toString();
	}
};

const shouldShowField = (key, value) => {
	// Don't show internal fields or null values
	const hiddenFields = [
		"employeeData",
		"studentData",
		"bookingTypeData",
		"roomData",
		"isCancelled",
		"modifiedAt"
	];

	// Always hide these internal data fields
	if (hiddenFields.includes(key)) {
		return false;
	}

	// Hide raw IDs when we have detailed data available
	if (key === "employee" && employeeData.value) return false;
	if (key === "student" && studentData.value) return false;
	if (key === "room" && roomData.value) return false;
	if (key === "bookingType" && bookingTypeData.value) return false;

	// title/description are meaningful even when empty ("Kein Titel"/"Keine Beschreibung"
	// via formatFieldValue) — don't hide the row entirely just because the value is null
	if (key === "title" || key === "description") return true;

	return value !== null && value !== undefined;
};

const hasChanged = (key) => {
	const oldChanges = safeChangesOld.value;
	const newChanges = safeChangesNew.value;
	if (!oldChanges || !newChanges) return false;

	const oldValue = oldChanges[key];
	const newValue = newChanges[key];
	// arrays (e.g. a series' cancellation date list) must be compared by content — the backend
	// always sends full old/new snapshots, so an unchanged array field would otherwise show up
	// as "changed" via plain !== reference comparison
	if (Array.isArray(oldValue) && Array.isArray(newValue)) {
		return oldValue.length !== newValue.length || oldValue.some((value, index) => value !== newValue[index]);
	}
	return oldValue !== newValue;
};

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createCommentVNode(" Changes Section "),
      (__props.log.changes)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _cache[7] || (_cache[7] = _createElementVNode("h6", { class: "fw-bold text-primary mb-3" }, [
              _createElementVNode("i", { class: "fas fa-exchange-alt me-2" }),
              _createTextVNode(" Änderungen ")
            ], -1 /* CACHED */)),
            _createCommentVNode(" Created Action "),
            (__props.log.action === 'created')
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("strong", null, _toDisplayString(_unref(isSeriesLevelLog)(__props.log) ? 'Serie erstellt' : 'Buchung erstellt'), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(safeChangesNew.value, (value, key) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: key,
                          class: "col-md-6"
                        }, [
                          (shouldShowField(key, value))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                _createElementVNode("small", _hoisted_9, _toDisplayString(getFieldLabel(key)), 1 /* TEXT */),
                                _createElementVNode("div", _hoisted_10, _toDisplayString(formatFieldValue(key, value)), 1 /* TEXT */)
                              ]))
                            : _createCommentVNode("v-if", true)
                        ]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ])
                  ])
                ]))
              : (
            __props.log.action === 'changed' && __props.log.changes.old && __props.log.changes.new
          )
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createCommentVNode(" Changed Action "),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("strong", null, _toDisplayString(_unref(isSeriesLevelLog)(__props.log) ? 'Serie geändert' : 'Buchung geändert'), 1 /* TEXT */)
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, [
                            _cache[0] || (_cache[0] = _createElementVNode("h6", { class: "text-danger" }, [
                              _createElementVNode("i", { class: "fas fa-minus-circle me-1" }),
                              _createTextVNode(" Vorher ")
                            ], -1 /* CACHED */)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(safeChangesOld.value, (value, key) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: `old-${key}`,
                                class: "mb-2"
                              }, [
                                (hasChanged(key) && shouldShowField(key, value))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                      _createElementVNode("small", _hoisted_17, _toDisplayString(getFieldLabel(key)), 1 /* TEXT */),
                                      _createElementVNode("div", _hoisted_18, _toDisplayString(formatFieldValue(key, value)), 1 /* TEXT */)
                                    ]))
                                  : (shouldShowField(key, value))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                        _createElementVNode("small", _hoisted_20, _toDisplayString(getFieldLabel(key)), 1 /* TEXT */),
                                        _createElementVNode("div", _hoisted_21, _toDisplayString(formatFieldValue(key, value)), 1 /* TEXT */)
                                      ]))
                                    : _createCommentVNode("v-if", true)
                              ]))
                            }), 128 /* KEYED_FRAGMENT */))
                          ]),
                          _createElementVNode("div", _hoisted_22, [
                            _cache[1] || (_cache[1] = _createElementVNode("h6", { class: "text-success" }, [
                              _createElementVNode("i", { class: "fas fa-plus-circle me-1" }),
                              _createTextVNode(" Nachher ")
                            ], -1 /* CACHED */)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(safeChangesNew.value, (value, key) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: `new-${key}`,
                                class: "mb-2"
                              }, [
                                (hasChanged(key) && shouldShowField(key, value))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                      _createElementVNode("small", _hoisted_24, _toDisplayString(getFieldLabel(key)), 1 /* TEXT */),
                                      _createElementVNode("div", _hoisted_25, _toDisplayString(formatFieldValue(key, value)), 1 /* TEXT */)
                                    ]))
                                  : (shouldShowField(key, value))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                        _createElementVNode("small", _hoisted_27, _toDisplayString(getFieldLabel(key)), 1 /* TEXT */),
                                        _createElementVNode("div", _hoisted_28, _toDisplayString(formatFieldValue(key, value)), 1 /* TEXT */)
                                      ]))
                                    : _createCommentVNode("v-if", true)
                              ]))
                            }), 128 /* KEYED_FRAGMENT */))
                          ])
                        ])
                      ])
                    ])
                  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                : (__props.log.action === 'extracted')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createCommentVNode(" Extracted Action "),
                      _createElementVNode("div", _hoisted_29, [
                        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "card-header bg-info text-dark" }, [
                          _createElementVNode("strong", null, "Termin aus Serie gelöst")
                        ], -1 /* CACHED */)),
                        _createElementVNode("div", _hoisted_30, [
                          (__props.log.seriesId)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_31, [
                                _cache[2] || (_cache[2] = _createElementVNode("i", { class: "fas fa-arrow-up-right-from-square me-2" }, null, -1 /* CACHED */)),
                                _createTextVNode(" Dieser Termin wurde aus Serie #" + _toDisplayString(__props.log.seriesId) + " gelöst und ist seitdem ein eigenständiger Termin. ", 1 /* TEXT */)
                              ]))
                            : _createCommentVNode("v-if", true),
                          _createElementVNode("div", _hoisted_32, [
                            _createElementVNode("div", _hoisted_33, [
                              _cache[3] || (_cache[3] = _createElementVNode("h6", { class: "text-danger" }, [
                                _createElementVNode("i", { class: "fas fa-minus-circle me-1" }),
                                _createTextVNode(" Vorher ")
                              ], -1 /* CACHED */)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(safeChangesOld.value, (value, key) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: `old-${key}`,
                                  class: "mb-2"
                                }, [
                                  (hasChanged(key) && shouldShowField(key, value))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                        _createElementVNode("small", _hoisted_35, _toDisplayString(getFieldLabel(key)), 1 /* TEXT */),
                                        _createElementVNode("div", _hoisted_36, _toDisplayString(formatFieldValue(key, value)), 1 /* TEXT */)
                                      ]))
                                    : _createCommentVNode("v-if", true)
                                ]))
                              }), 128 /* KEYED_FRAGMENT */))
                            ]),
                            _createElementVNode("div", _hoisted_37, [
                              _cache[4] || (_cache[4] = _createElementVNode("h6", { class: "text-success" }, [
                                _createElementVNode("i", { class: "fas fa-plus-circle me-1" }),
                                _createTextVNode(" Nachher ")
                              ], -1 /* CACHED */)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(safeChangesNew.value, (value, key) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: `new-${key}`,
                                  class: "mb-2"
                                }, [
                                  (hasChanged(key) && shouldShowField(key, value))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                        _createElementVNode("small", _hoisted_39, _toDisplayString(getFieldLabel(key)), 1 /* TEXT */),
                                        _createElementVNode("div", _hoisted_40, _toDisplayString(formatFieldValue(key, value)), 1 /* TEXT */)
                                      ]))
                                    : _createCommentVNode("v-if", true)
                                ]))
                              }), 128 /* KEYED_FRAGMENT */))
                            ])
                          ])
                        ])
                      ])
                    ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                  : (__props.log.action === 'cancelled')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                        _createCommentVNode(" Cancelled Action "),
                        _createElementVNode("div", _hoisted_41, [
                          _createElementVNode("div", _hoisted_42, [
                            _createElementVNode("strong", null, _toDisplayString(_unref(isSeriesLevelLog)(__props.log) ? 'Serie storniert' : 'Buchung storniert'), 1 /* TEXT */)
                          ]),
                          _createElementVNode("div", _hoisted_43, [
                            _createElementVNode("p", _hoisted_44, [
                              _cache[6] || (_cache[6] = _createElementVNode("i", { class: "fas fa-ban me-2" }, null, -1 /* CACHED */)),
                              _createTextVNode(" " + _toDisplayString(_unref(isSeriesLevelLog)(__props.log) ? 'Diese Serie wurde storniert.' : 'Diese Buchung wurde storniert.') + " Keine weiteren Details verfügbar. ", 1 /* TEXT */)
                            ])
                          ])
                        ])
                      ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                    : _createCommentVNode("v-if", true)
          ]))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" Additional Information "),
      _createElementVNode("div", _hoisted_45, [
        _cache[25] || (_cache[25] = _createElementVNode("h6", { class: "fw-bold text-primary mb-3" }, [
          _createElementVNode("i", { class: "fas fa-info-circle me-2" }),
          _createTextVNode(" Zusätzliche Informationen ")
        ], -1 /* CACHED */)),
        _createCommentVNode(" Employee Details "),
        (employeeData.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
              _cache[9] || (_cache[9] = _createElementVNode("div", { class: "card-header bg-transparent border-bottom" }, [
                _createElementVNode("strong", null, [
                  _createElementVNode("i", { class: "fas fa-user-tie me-2" }),
                  _createTextVNode(" Mitarbeiter ")
                ])
              ], -1 /* CACHED */)),
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("p", _hoisted_48, [
                  _createElementVNode("strong", _hoisted_49, _toDisplayString(employeeData.value.firstname) + " " + _toDisplayString(employeeData.value.lastname), 1 /* TEXT */)
                ]),
                (employeeData.value.email)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_50, [
                      _cache[8] || (_cache[8] = _createElementVNode("i", { class: "fas fa-envelope me-1" }, null, -1 /* CACHED */)),
                      _createElementVNode("a", {
                        href: `mailto:${employeeData.value.email}`,
                        class: "text-decoration-none",
                        style: {"word-break":"break-all","overflow-wrap":"break-word","max-width":"100%","white-space":"normal","color":"var(--accent-primary)"}
                      }, _toDisplayString(employeeData.value.email), 9 /* TEXT, PROPS */, _hoisted_51)
                    ]))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("p", _hoisted_52, [
                  _createElementVNode("small", null, "ID: " + _toDisplayString(employeeData.value.id), 1 /* TEXT */)
                ])
              ])
            ]))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" Student Details "),
        (studentData.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
              _cache[11] || (_cache[11] = _createElementVNode("div", { class: "card-header bg-transparent border-bottom" }, [
                _createElementVNode("strong", null, [
                  _createElementVNode("i", { class: "fas fa-user-graduate me-2" }),
                  _createTextVNode(" Student ")
                ])
              ], -1 /* CACHED */)),
              _createElementVNode("div", _hoisted_54, [
                _createElementVNode("p", _hoisted_55, [
                  _createElementVNode("strong", _hoisted_56, _toDisplayString(studentData.value.firstname) + " " + _toDisplayString(studentData.value.lastname), 1 /* TEXT */)
                ]),
                (studentData.value.email)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_57, [
                      _cache[10] || (_cache[10] = _createElementVNode("i", { class: "fas fa-envelope me-1" }, null, -1 /* CACHED */)),
                      _createElementVNode("a", {
                        href: `mailto:${studentData.value.email}`,
                        class: "text-decoration-none",
                        style: {"word-break":"break-all","overflow-wrap":"break-word","max-width":"100%","white-space":"normal","color":"var(--accent-primary)"}
                      }, _toDisplayString(studentData.value.email), 9 /* TEXT, PROPS */, _hoisted_58)
                    ]))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("p", _hoisted_59, [
                  _createElementVNode("small", null, "ID: " + _toDisplayString(studentData.value.id), 1 /* TEXT */)
                ])
              ])
            ]))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" Booking Kind "),
        _createElementVNode("div", _hoisted_60, [
          _cache[12] || (_cache[12] = _createElementVNode("div", { class: "card-header bg-transparent border-bottom" }, [
            _createElementVNode("strong", null, [
              _createElementVNode("i", { class: "fas fa-coins me-2" }),
              _createTextVNode(" Buchungstyp ")
            ])
          ], -1 /* CACHED */)),
          _createElementVNode("div", _hoisted_61, [
            _createElementVNode("p", _hoisted_62, _toDisplayString(_unref(getLogBookingKindLabel)(__props.log)), 1 /* TEXT */)
          ])
        ]),
        _createCommentVNode(" Booking Type Details "),
        (bookingTypeData.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
              _cache[13] || (_cache[13] = _createElementVNode("div", { class: "card-header bg-transparent border-bottom" }, [
                _createElementVNode("strong", null, [
                  _createElementVNode("i", { class: "fas fa-tag me-2" }),
                  _createTextVNode(" Typ ")
                ])
              ], -1 /* CACHED */)),
              _createElementVNode("div", _hoisted_64, [
                _createElementVNode("p", _hoisted_65, [
                  _createElementVNode("span", {
                    class: "badge",
                    style: _normalizeStyle({
                  backgroundColor: bookingTypeData.value.backgroundColor,
                  color: bookingTypeData.value.textColor,
                })
                  }, _toDisplayString(bookingTypeData.value.title), 5 /* TEXT, STYLE */)
                ])
              ])
            ]))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" Room Details "),
        (displayRoomData.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
              _cache[18] || (_cache[18] = _createElementVNode("div", { class: "card-header bg-transparent border-bottom" }, [
                _createElementVNode("strong", null, [
                  _createElementVNode("i", { class: "fas fa-door-open me-2" }),
                  _createTextVNode(" Raumdetails ")
                ])
              ], -1 /* CACHED */)),
              _createElementVNode("div", _hoisted_67, [
                (displayRoomData.value.building)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                      _cache[14] || (_cache[14] = _createElementVNode("small", { class: "text-muted d-block" }, "Standort", -1 /* CACHED */)),
                      _createElementVNode("span", null, _toDisplayString(displayRoomData.value.building.short) + " - " + _toDisplayString(displayRoomData.value.building.name), 1 /* TEXT */)
                    ]))
                  : _createCommentVNode("v-if", true),
                (displayRoomData.value.name)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                      _cache[15] || (_cache[15] = _createElementVNode("small", { class: "text-muted d-block" }, "Name", -1 /* CACHED */)),
                      _createElementVNode("div", _hoisted_70, _toDisplayString(displayRoomData.value.name), 1 /* TEXT */)
                    ]))
                  : _createCommentVNode("v-if", true),
                (displayRoomData.value.doorLabel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                      _cache[16] || (_cache[16] = _createElementVNode("small", { class: "text-muted d-block" }, "Label", -1 /* CACHED */)),
                      _createElementVNode("span", null, _toDisplayString(displayRoomData.value.doorLabel), 1 /* TEXT */)
                    ]))
                  : _createCommentVNode("v-if", true),
                (displayRoomData.value.number)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                      _cache[17] || (_cache[17] = _createElementVNode("small", { class: "text-muted d-block" }, "Raum #", -1 /* CACHED */)),
                      _createElementVNode("span", null, _toDisplayString(displayRoomData.value.number), 1 /* TEXT */)
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" Meta Information "),
        _createElementVNode("div", _hoisted_73, [
          _cache[24] || (_cache[24] = _createElementVNode("div", { class: "card-header bg-transparent border-bottom" }, [
            _createElementVNode("strong", null, [
              _createElementVNode("i", { class: "fas fa-tags me-2" }),
              _createTextVNode(" Metadaten ")
            ])
          ], -1 /* CACHED */)),
          _createElementVNode("div", _hoisted_74, [
            _createElementVNode("div", _hoisted_75, [
              _cache[19] || (_cache[19] = _createElementVNode("small", { class: "text-muted d-block" }, "Benutzer", -1 /* CACHED */)),
              _createElementVNode("div", _hoisted_76, [
                (__props.log.user?.displayName)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(__props.log.user.displayName), 1 /* TEXT */)
                    ], 64 /* STABLE_FRAGMENT */))
                  : (__props.log.user?.username)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (__props.log.user.username.includes('@'))
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              href: `mailto:${__props.log.user.username}`,
                              class: "text-decoration-none",
                              style: {"color":"var(--accent-primary)"}
                            }, _toDisplayString(__props.log.user.username), 9 /* TEXT, PROPS */, _hoisted_77))
                          : (_openBlock(), _createElementBlock("span", _hoisted_78, _toDisplayString(__props.log.user.username), 1 /* TEXT */))
                      ], 64 /* STABLE_FRAGMENT */))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _createTextVNode(" - ")
                      ], 64 /* STABLE_FRAGMENT */))
              ])
            ]),
            (__props.log.user?.username && __props.log.user?.displayName)
              ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                  _cache[20] || (_cache[20] = _createElementVNode("small", { class: "text-muted d-block" }, "Benutzername", -1 /* CACHED */)),
                  _createElementVNode("div", _hoisted_80, _toDisplayString(__props.log.user.username), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_81, [
              _cache[21] || (_cache[21] = _createElementVNode("small", { class: "text-muted d-block" }, "Log-Zeitstempel", -1 /* CACHED */)),
              _createElementVNode("div", _hoisted_82, _toDisplayString(formatDate(__props.log.logDate)), 1 /* TEXT */)
            ]),
            _createElementVNode("div", _hoisted_83, [
              _cache[22] || (_cache[22] = _createElementVNode("small", { class: "text-muted d-block" }, "Aktion", -1 /* CACHED */)),
              _createElementVNode("span", {
                class: _normalizeClass(["badge", actionBadgeClass.value])
              }, _toDisplayString(_unref(getActionLabel)(__props.log.action)), 3 /* TEXT, CLASS */)
            ]),
            _createElementVNode("div", _hoisted_84, [
              _cache[23] || (_cache[23] = _createElementVNode("small", { class: "text-muted d-block" }, "Zugehörigkeit", -1 /* CACHED */)),
              (_unref(isSeriesLevelLog)(__props.log))
                ? (_openBlock(), _createElementBlock("span", _hoisted_85, " ⟲ Serie #" + _toDisplayString(__props.log.seriesId), 1 /* TEXT */))
                : (__props.log.seriesId)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_86, " Teil der Serie #" + _toDisplayString(__props.log.seriesId), 1 /* TEXT */))
                  : (_openBlock(), _createElementBlock("span", _hoisted_87, " Einzeltermin "))
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

}